import {useEffect, useRef} from "react";


const useUpdateOnlyEffect = (effect, dependencies) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
  }, dependencies);
};

export default useUpdateOnlyEffect;
